import { render, staticRenderFns } from "./Clipart.vue?vue&type=template&id=7cc47384"
import script from "./Clipart.vue?vue&type=script&lang=js"
export * from "./Clipart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports